import React from 'react';
import * as Styled from './style';

interface CommonQuestion {
  question: string;
  answer: string;
}

interface Props {
  data: {
    commonQuestions: CommonQuestion[];
  };
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  errors: {
    commonQuestions?: string[];
  };

   setErrors: React.Dispatch<React.SetStateAction<any>>;
      handleChange: (
        e:
          | React.ChangeEvent<HTMLInputElement>
          | React.ChangeEvent<HTMLTextAreaElement>
          | React.ChangeEvent<HTMLSelectElement>
      ) => void;
      handleBlur: (
        e:
          | React.ChangeEvent<HTMLInputElement>
          | React.ChangeEvent<HTMLTextAreaElement>
          | React.ChangeEvent<HTMLSelectElement>
      ) => void;

  handleNext: () => void;
  handleBack: () => void;
}

export default function StepSix({
  data,
  setFormData,
  errors,
  handleNext,
  handleBack,
}: Props) {
  const handleQuestionChange = (
    index: number,
    field: 'question' | 'answer',
    value: string
  ) => {
    const updated = [...data.commonQuestions];
    updated[index][field] = value;
    setFormData((prev: any) => ({
      ...prev,
      commonQuestions: updated,
    }));
  };

  const addCommonQuestion = () => {
    setFormData((prev: any) => ({
      ...prev,
      commonQuestions: [
        ...prev.commonQuestions,
        { question: '', answer: '' },
      ],
    }));
  };

  return (
    <>
      <Styled.Title>Common Questions & Client Education</Styled.Title>

      <Styled.Group>
        <Styled.Label>
          What are the most common questions your clients ask and how would you like the chatbot to respond?{' '}
          <Styled.HelperText>(Optional)</Styled.HelperText>
        </Styled.Label>

        {data.commonQuestions.map((item, index) => (
          <Styled.SubGroup key={index}>
            <Styled.Input
              type="text"
              placeholder="Common client question"
              value={item.question}
              onChange={(e) =>
                handleQuestionChange(index, 'question', e.target.value)
              }
            />
            <Styled.Textarea
              placeholder="How would you like the chatbot to respond?"
              value={item.answer}
              onChange={(e) =>
                handleQuestionChange(index, 'answer', e.target.value)
              }
            />
          </Styled.SubGroup>
        ))}

        <Styled.AddButton type="button" onClick={addCommonQuestion}>
          + Add another common question
        </Styled.AddButton>

        {errors.commonQuestions && (
          <Styled.Error>{errors.commonQuestions[0]}</Styled.Error>
        )}
      </Styled.Group>

      <Styled.ButtonGroup>
        <Styled.Button type="button" onClick={handleBack}>
          Go back
        </Styled.Button>
        <Styled.Button type="button" onClick={handleNext}>
          Last step: lead information →
        </Styled.Button>
      </Styled.ButtonGroup>
    </>
  );
}
